import React from 'react'

export default <>
  <rect x="16.2161" y="10.0737" width="40" height="40" rx="1" stroke="white" strokeWidth="2" />
  <rect x="21.7244" y="16.8091" width="29.571" height="2.19449" rx="1.09725" stroke="white" strokeWidth="1.5" />
  <rect x="21.7244" y="24.7642" width="29.571" height="2.19449" rx="1.09725" stroke="white" strokeWidth="1.5" />
  <rect x="21.7244" y="33.1892" width="29.571" height="2.19449" rx="1.09725" stroke="white" strokeWidth="1.5" />
  <rect x="21.7244" y="41.144" width="29.571" height="2.19449" rx="1.09725" stroke="white" strokeWidth="1.5" />
</>